import { Component, OnDestroy, OnInit } from '@angular/core';
import { Filter } from '@docpath/linces-angular-components/common';
import { Table } from '@docpath/webcomponents';
import { Subscription } from 'rxjs';

import { EnginesTableService } from './components/table/engines-table.service';
import { Dge } from './models/dge';
import { EnginesService } from './services/engines.service';

@Component({
    selector: 'app-configuration-engines',
    templateUrl: './engines.component.html'
})
export class EnginesComponent implements OnInit, OnDestroy {

    private table?: Table;
    private engineSubscription?: Subscription;
    selectedDge: Dge[] = [];
    filters: Filter[] = [];

    constructor(
        private readonly enginesTableService: EnginesTableService,
        private readonly enginesService: EnginesService
    ) {}

    ngOnInit(): void {
        if (!this.engineSubscription) {
            this.engineSubscription = this.enginesService.engineChanged.subscribe(() => this.refreshEngines());
        }
    }

    ngOnDestroy(): void {
        if (this.engineSubscription) {
            this.engineSubscription.unsubscribe();
        }
    }

    getTable(): Table | undefined {
        return this.table;
    }

    onTableLoaded(table: Table): void {
        this.table = table;
    }

    onCheckChange(): void {
        if (this.table) {
            this.selectedDge = this.enginesTableService.getSelectedDge(this.table);
        }
    }

    onFilterChange(filters: Filter[]): void {
        this.filters = filters;
    }

    private refreshEngines(): void {
        this.enginesTableService.loadDges(this.filters, 1);
    }

}